import { createTheme } from '@material-ui/core/styles';
import purple from '@material-ui/core/colors/purple';
import green from '@material-ui/core/colors/green';
import LovesRegttf from './fonts/LOVES.ttf';

const Loves = {
  fontFamily: 'Loves',
  fontStyle: 'normal',
  fontDisplay: 'swap',
  fontWeight: 400,
  src: `
    url(${LovesRegttf}) format('truetype')
  `,
};

export default function theme() {
  return createTheme({
  palette: {
    primary: {
      main: '#027273',
    },
    secondary: {
      main: '#d1dafb',
    },
    gradient: {
      default: 'linear-gradient( 136deg, rgb(208,235,254) 0%, rgb(209,218,251) 10%, rgb(221,228,255) 20%, rgb(221,221,255) 30%, rgb(245,230,255) 40%, rgb(255,231,255) 70%, rgb(251,226,226) 100%)'
    },
    // background: {
    //   default: 'linear-gradient( 136deg, rgb(208,235,254) 0%, rgb(209,218,251) 10%, rgb(221,228,255) 20%, rgb(221,221,255) 30%, rgb(245,230,255) 40%, rgb(255,231,255) 70%, rgb(251,226,226) 100%)'
    // }
  },
  typography: {
    h5: {
      fontFamily: "Loves",
      fontSize: "2rem",
    },
    h2: {
      fontFamily: "Loves",
      fontSize: "3.25rem",
    },
    h3: {
      fontFamily: "Loves",
      fontSize: "3.25rem",
    },
    h6: {
      fontFamily: "Loves",
      fontSize: "1.5rem",
    }
   ,
  },
  overrides: {
    MuiCssBaseline: {
      '@global': {
        '@font-face': [Loves],
        body: {
          background: 'linear-gradient( rgb(255,255,255) 0%, rgb(255,255,255) 50%, rgb(255,231,255) 80%, rgb(251,226,226) 100%)'},
      },
    },
  },
}); }

// d1dafb